import { RoleListPage } from '@/features/access/pages/role/RoleListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/role/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_roles.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: RoleListPage,
})
